import React from 'react'
import { View, ViewStyle } from 'react-native'
import { Route } from 'react-native-tab-view'

import { Text } from 'widgets/Text'

// This is our placeholder component for the tabs
// This will be rendered when a tab isn't loaded yet
// You could also customize it to render different content depending on the route
export const CustomLazyPlaceholder = ({ route, style }: { route: Route; style: ViewStyle }) => (
  <View style={style}>
    <Text>Loading…</Text>
  </View>
)
